<div class="media-access-prompt">
  <fa-duotone-icon [icon]="icon()"></fa-duotone-icon>
  <andor-notice variant="info">{{ text() }}</andor-notice>
  <andor-button type="gradient" (click)="requestAccess()">
    <span>{{ 'Request Access' | translate }}</span>
  </andor-button>
</div>
